import { event, set } from 'vue-gtag'
import store from '@/store/index'

/**
 * Módulos de negocio que se trackean (public.business_modules).
 * Clave: path base del módulo en el router (tal como aparece en route.matched).
 * Valor: identidad estable del módulo para reportar a GA.
 */
const TRACKED_MODULES = {
  '/dashboard': { id: 1, name: 'Dashboard', type: 'COMMERCIAL' },
  '/weekly-sales': { id: 2, name: 'WeeklySales', type: 'COMMERCIAL' },
  '/daily-sales': { id: 4, name: 'DailySales', type: 'COMMERCIAL' }
}

/**
 * Resuelve el módulo de negocio a partir de los registros emparejados de la ruta.
 * @param {import('vue-router').Route} route
 * @returns {{ id: number, name: string, type: string } | null}
 */
function resolveModule (route) {
  if (!route || !Array.isArray(route.matched)) return null
  const record = route.matched.find(matched => TRACKED_MODULES[matched.path])
  return record ? TRACKED_MODULES[record.path] : null
}

let lastIdentifiedUserId = null

/**
 * Asocia los eventos de GA al usuario actual usando su id interno (nunca PII).
 * Se ejecuta una sola vez por usuario para no repetir la llamada en cada navegación.
 * @returns {string | null} id del usuario o null si no hay sesión cargada.
 */
function identifyUser () {
  const userInfo = store.getters.userInfo
  const userId = userInfo && userInfo.id != null ? String(userInfo.id) : null
  if (!userId || userId === lastIdentifiedUserId) return userId

  set({
    user_id: userId,
    user_properties: {
      client_id: userInfo.client_id != null ? String(userInfo.client_id) : undefined
    }
  })
  lastIdentifiedUserId = userId
  return userId
}

/**
 * Registra el consumo de un módulo de negocio cuando el usuario entra en él.
 * Solo dispara al cambiar de módulo (no en navegación interna) para no inflar el conteo.
 * @param {import('vue-router').Route} to
 * @param {import('vue-router').Route} from
 */
export function trackModuleView (to, from) {
  const target = resolveModule(to)
  if (!target) return

  const origin = resolveModule(from)
  if (origin && origin.id === target.id) return

  const userId = identifyUser()

  event('module_view', {
    module_id: target.id,
    module_name: target.name,
    module_type: target.type,
    app_user_id: userId || undefined
  })
}



// WEBPACK FOOTER //
// ./src/app/shared/analytics/moduleTracking.js